export function mergeInstantChatReviewers(existing: string[], pending: string): string[] {
    const next: string[] = [];
    const seen = new Set<string>();
    for (const raw of [...existing, pending]) {
        const trimmed = raw.trim();
        if (!trimmed) {
            continue;
        }
        const key = trimmed.toLowerCase();
        if (seen.has(key)) {
            continue;
        }
        seen.add(key);
        next.push(trimmed);
    }
    return next;
}

export function instantChatAccessNotice(companyName: string, reviewers: string[]): string {
    const name = companyName.trim() || "this organisation";
    if (reviewers.length === 0) {
        return `Instant Chat is off for ${name}.`;
    }
    if (reviewers.length === 1) {
        return `Instant Chat is off for ${name}, except for the reviewer you listed.`;
    }
    return `Instant Chat is off for ${name}, except for the reviewers you listed.`;
}
